import { useExperimentBucket } from '@carvana/experiment';
import { useContext, useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import type WithClassName from './WithClassName';

function CabTypes({ className }: WithClassName) {
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const [expand, setExpand] = useState(false);

  const show =
    (experimentBucket === 'control'
      ? appliedFilters.bodyStyles?.includes('Pickup') &&
        facetData?.truckCabTypes?.buckets &&
        facetData?.truckCabTypes?.buckets?.length > 0
      : facetData?.truckCabTypes?.buckets.some(
          cabTypes => cabTypes.count > 0
        )) || false;

  useEffect(() => {
    if (!show) setExpand(false);
  }, [show]);

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-cab-type"
        facetContent={facetData?.truckCabTypes?.buckets}
        facetName="Cab Options"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <CommonWrapper>
          {facetData?.truckCabTypes?.buckets?.map(
            ({ count, displayName, key }) => (
              <Checkbox
                facet="truckCabTypes"
                filter={key}
                id={`cab-type-${key}`}
                key={key}
                label={
                  <LabelWithCount count={count} displayName={displayName} />
                }
                checked={appliedFilters.truckCabTypes?.includes(key)}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'truckCabTypes',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}

export default CabTypes;
